// extracted by mini-css-extract-plugin
export var progressBar = "_a2-0";